import React, {useCallback, useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import i18n from "../../lang/i18n";
import {Navbar,  Container} from "react-bootstrap";

import {
    setAddress, setBalance, setConnected,
    setKind,
} from "../../redux/slice/walletSlice";

import './RevealHeaderNav.css'
import logo from 'asset/logo/logo_original.svg';
import menuIcon from 'asset/icon/ic_menu_purple_24dp.png';
import closeMenu from 'asset/icon/ic_clear_purple_24dp.png';
import havah from 'asset/logo/havah.png';


function RevealHeaderNav(props) {
    const connectWallet = props.walletConnectFunc;

    const dispatch = useDispatch();

    //const walletKind = useSelector(state => state.walletSlice.kind );
    const walletConnected = useSelector(state => state.walletSlice.connected );
    const walletAddress = useSelector(state => state.walletSlice.address );
    //const walletBalance = useSelector(state => state.walletSlice.balance );

    const [language, setLanguage] = useState("en-US");

    useEffect(()=>{
        i18n.changeLanguage(language);
    },[language]);

    const funcChangeLang = useCallback( async (target, lang) =>{
       const classList = target.classList;

       classList.toggle('current');

        if(classList.contains("ko-btn")){
            document.querySelectorAll('.ko-btn').forEach((item)=>{
                item.classList.add('current');
            })
            document.querySelectorAll('.en-btn').forEach((item)=>{
                item.classList.remove('current');
            })
        }else if(classList.contains("en-btn")){
            document.querySelectorAll('.ko-btn').forEach((item)=>{
                item.classList.remove('current');
            })
            document.querySelectorAll('.en-btn').forEach((item)=>{
                item.classList.add('current');
            })
        }

       setLanguage(lang);
    });

    const disconnectWallet = async (kind) =>{
        dispatch(setAddress(''));
        dispatch(setKind(""));
        dispatch(setBalance('0.0'));
        dispatch(setConnected(false));
        document.querySelector(".connect-wallet-list-container").style.display = "none";
    }
    // Hover 이벤트
    function funcWalletBtnMouseEnter(target){
        if(walletConnected){
            target.querySelector(".connect-wallet-list-container").style.display = "flex";
        }
    };
    function funcWalletBtnMouseLeave(target){
        if(walletConnected){
            target.querySelector(".connect-wallet-list-container").style.display = "none";
        }
    };

    function textWallet () {
        if(walletConnected){
            const text = walletAddress.substring(0,6) + '...' + walletAddress.substring(walletAddress.length-6,walletAddress.length);
            return (
                <div className="connect-wallet-btn">
                    {text}
                </div>
            )
        }else{
            return (
                <div className="connect-wallet-btn"
                     onClick={()=>{connectWallet("havah")}}>
                    <img className={"metamaskIcon"} src={havah} alt="connect havah" width={24} height={24} />
                    CONNECT WALLET
                </div>
            );
        }
    }

    function funcToggleMenu() {
        document.querySelector('.fixed-menu-wrap').classList.toggle("open");
    }

    return (
        <>
            <Navbar collapseOnSelect fixed={"top"} expand={"sm"}>
                <Container>
                    <img className={"header-nav-logo"} src={logo} alt="logo" onClick={()=>{window.location.href="https://perplay.io"}}/>

                    <div className={"nav-menu-toggle"}
                    onClick={(e)=>(funcToggleMenu())}>
                        <img src={menuIcon} width={24} height={24}/>
                    </div>
                    <div className={"nav-menu-wrap"}>
                        <div className={"connect-wallet-wrap"}>
                            <div className={"connect-wallet-container"}
                                 onMouseEnter={(e)=>(funcWalletBtnMouseEnter(e.currentTarget))}
                                 onMouseLeave={(e)=>(funcWalletBtnMouseLeave(e.currentTarget))}
                                 onTouchStart={(e)=>(funcWalletBtnMouseEnter(e.currentTarget))}
                            >

                                {textWallet()}
                                <div className={"connect-wallet-list-container"}>
                                    <ul className={"connect-wallet-list"}>
                                        <li>
                                            <div onClick={()=>{disconnectWallet("havah")}} className={"connect-metamask-btn wallet-btn"}>
                                                DISCONNECT
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className={"lang-wrap"}>
                            <div id="lang-icon"></div>
                            <div onClick={(e)=>{funcChangeLang(e.currentTarget,"en-US")}} className={"en-btn lang-btn current"}>EN</div>
                            <div onClick={(e)=>{funcChangeLang(e.currentTarget,"ko-KR")}} className={"ko-btn lang-btn"}>KO</div>
                        </div>
                    </div>
                </Container>
            </Navbar>
            <div className={"fixed-menu-wrap"}>
                <div className={"fixed-menu-div"}>
                    <img onClick={(e)=>(funcToggleMenu())} className={"fixed-menu-close-icon"} src={closeMenu} width={24} height={24} />
                    <div className={"lang-wrap"}>
                        <div id="lang-icon"></div>
                        <div onClick={(e)=>{funcChangeLang(e.currentTarget,"en-US")}} className={"en-btn lang-btn current"}>EN</div>
                        <div onClick={(e)=>{funcChangeLang(e.currentTarget,"ko-KR")}} className={"ko-btn lang-btn"}>KO</div>
                    </div>
                    <div className={"connect-wallet-wrap"}>
                        <div className={"connect-wallet-container"}
                             onMouseEnter={(e)=>(funcWalletBtnMouseEnter(e.currentTarget))}
                             onMouseLeave={(e)=>(funcWalletBtnMouseLeave(e.currentTarget))}>

                            {textWallet()}
                            <div className={"connect-wallet-list-container"}>
                                <ul className={"connect-wallet-list"}>
                                    <li>
                                        <div onClick={()=>{disconnectWallet("havah")}} className={"connect-metamask-btn wallet-btn"}>
                                            DISCONNECT
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RevealHeaderNav;